import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_STATIC_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  USER_DELETED,
  FETCH_ALL_DRIVERS,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, update, off, get, remove } from "firebase/database";
import { uploadBytesResumable , getDownloadURL } from "firebase/storage";
import { signOut } from "firebase/auth";
import store from '../store/store';
import { revokeUserTokens } from './authactions';

export const fetchUsers = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .filter(i => data[i].usertype!='admin')
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    }
  });
};


export const fetchUsersOnce = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_STATIC_SUCCESS,
        payload: arr
      })
    } else {
      dispatch({
        type: FETCH_ALL_USERS_STATIC_FAILED,
        payload: "No users available."
      });
    }
  },{onlyOnce: true});
};

export const clearFetchDrivers = () => (dispatch) => {
  const {
    driversRef,
    allLocationsRef,
  } = firebase;
  off(driversRef);
  off(allLocationsRef);
}


export const fetchDrivers = (appType) => async(dispatch) => {

  const {
    driversRef,
    allLocationsRef,
    settingsRef,
  } = firebase;

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null
  });

  onValue(driversRef, snapshot => {
    if (snapshot.val()) {
      onValue(allLocationsRef, locres=>{
        const locations = locres.val();
          const data = snapshot.val();
          const arr = Object.keys(data)
          .filter(i => data && data[i].approved == true  && locations && locations[i] &&( (data[i].licenseImage && settings.license_image_required) || !settings.license_image_required)
          && (((data[i].carApproved && settings.carType_required) || !settings.carType_required) || !settings.carType_required) && ((data[i].term && settings.term_required) || !settings.term_required) ) 
          .map(i => {
            return {
              id: i,
              location: locations && locations[i] ? locations[i]:null,
              carType: data[i].carType ? data[i].carType : null,
              vehicleNumber:  data[i].vehicleNumber ? data[i].vehicleNumber : null,
              fleetadmin:  data[i].fleetadmin ? data[i].fleetadmin : null,
              firstName: data[i].firstName,
              lastName: data[i].lastName,
              activeCar_position: data[i].activeCar_position,
              queue: data[i].queue,
              driverActiveStatus: data[i].driverActiveStatus,
              category: data[i].category,
              blockedCustomers: data[i].blockedCustomers ? data[i].blockedCustomers : null
            };
          });
          dispatch({
            type: FETCH_ALL_DRIVERS_SUCCESS,
            payload: arr
          });
      }, appType === 'app'? {onlyOnce: true}: null)
    } else {
      dispatch({
        type: FETCH_ALL_DRIVERS_FAILED,
        payload: "No users available."
      });
    }
  },appType === 'app'? {onlyOnce: true}: null);
};

export const addUser = (userdata) => async (dispatch) => {
  return new Promise((resolve, reject) => {
    const { usersRef } = firebase;
    const countries = store.getState().countrylistdata.countries;

    let countryDetail;
    for (let i = 0; i < countries.length; i++) {
      if (countries[i].country === userdata.country) {
        countryDetail = countries[i];
        break;
      }
    }

    if (!countryDetail) {
      const error = new Error(JSON.stringify({ errorType: 'country_not_found' }));
      dispatch({ type: EDIT_USER_FAILED, payload: error });
      return reject(error);
    }

    const expectedMobileLength = countryDetail.phone_code.length + countryDetail.mobile_length;
    const actualMobileLength = userdata.mobile.replace(/[^0-9]/g, '').length;

    if (actualMobileLength !== expectedMobileLength) {
      const error = new Error(JSON.stringify({
        errorType: 'invalid_mobile_length',
        expectedMobileLength,
        actualMobileLength
      }));
      dispatch({ type: EDIT_USER_FAILED, payload: error });
      return reject(error);
    }

    userdata['country'] = countryDetail.country;
    userdata['country_code'] = countryDetail.country_code;
    userdata['currency_code'] = countryDetail.currency_code;
    userdata['swipe_symbol'] = countryDetail.swipe_symbol;
    userdata['symbol'] = countryDetail.symbol;

    delete userdata.tableData;

    dispatch({ type: EDIT_USER, payload: userdata });

    push(usersRef, userdata)
      .then(() => {
        dispatch({ type: EDIT_USER_SUCCESS, payload: null });
        resolve();
      })
      .catch((error) => {
        dispatch({ type: EDIT_USER_FAILED, payload: error });
        reject(error);
      });
  });
};

export const editUser = (id, user, method) => async (dispatch) => {
  const { singleUserRef, profileImage } = firebase;

  try {
    dispatch({
      type: EDIT_USER,
      payload: user,
    });

    if (method === 'UpdateImage') {
      const uploadTask = await uploadBytesResumable(profileImage(id), user.profile_image);
      const imageUrl = await getDownloadURL(uploadTask.ref);

      const updatedUser = {
        ...user,
        profile_image: imageUrl,
        updateAt: new Date().getTime(),
      };
      if (updatedUser.tableData) delete updatedUser.tableData;
      await update(singleUserRef(id), updatedUser);

    } else {
      const { id: removedId, tableData: removedTableData, ...restUser } = user;
      await update(singleUserRef(id), restUser);
    }
  } catch (error) {
    console.error("Error updating user:", error);
  }
};

export const fetchSingleUser = (uid) => {
  return new Promise((resolve, reject) => {
    const { singleUserRef } = firebase;
    get(singleUserRef(uid)).then((snapshot) => {
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        resolve(null);
      }
    }).catch(error => reject(error));
  });
};
export const updateUserCar = (id, data) => (dispatch) => {
  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: data  
  });
  update(singleUserRef(id),data);
}

export const updateLicenseImage = (uid, imageBlob, imageType) => async (dispatch) => {

  const {
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef,
    verifyIdImageBackRef,
    photoWithLicenseRef,
    policeClearanceRef
  } = firebase;

  let profile = {};

  const getContentType = (blob) => {
    if (blob && blob.type && blob.type !== 'application/octet-stream') {
      return blob.type;
    }
    return 'image/jpeg';
  };

  if(imageType === 'licenseImage'){
    const isPdf = imageBlob.type === 'application/pdf';
    const metadata = { contentType: isPdf ? 'application/pdf' : getContentType(imageBlob) };
    await uploadBytesResumable(driverDocsRef(uid),imageBlob, metadata);
    let image = await getDownloadURL(driverDocsRef(uid));
    if (isPdf) image += image.includes('?') ? '&ext=.pdf' : '?ext=.pdf';
    profile.licenseImage = image;
  }
  if(imageType === 'licenseImageBack'){
    const isPdf = imageBlob.type === 'application/pdf';
    const metadata = { contentType: isPdf ? 'application/pdf' : getContentType(imageBlob) };
    await uploadBytesResumable(driverDocsRefBack(uid),imageBlob, metadata);
    let image1 = await getDownloadURL(driverDocsRefBack(uid));
    if (isPdf) image1 += image1.includes('?') ? '&ext=.pdf' : '?ext=.pdf';
    profile.licenseImageBack = image1;
  }
  if(imageType === 'verifyIdImage'){
    const isPdf = imageBlob.type === 'application/pdf';
    const metadata = { contentType: isPdf ? 'application/pdf' : getContentType(imageBlob) };
    await uploadBytesResumable(verifyIdImageRef(uid),imageBlob, metadata);
    let image1 = await getDownloadURL(verifyIdImageRef(uid));
    if (isPdf) image1 += image1.includes('?') ? '&ext=.pdf' : '?ext=.pdf';
    profile.verifyIdImage = image1;
  }
  if(imageType === 'verifyIdImageBack'){
    const isPdf = imageBlob.type === 'application/pdf';
    const metadata = { contentType: isPdf ? 'application/pdf' : getContentType(imageBlob) };
    await uploadBytesResumable(verifyIdImageBackRef(uid),imageBlob, metadata);
    let image1 = await getDownloadURL(verifyIdImageBackRef(uid));
    if (isPdf) image1 += image1.includes('?') ? '&ext=.pdf' : '?ext=.pdf';
    profile.verifyIdImageBack = image1;
  }
  if(imageType === 'photoWithLicense'){
    const metadata = { contentType: getContentType(imageBlob) };
    await uploadBytesResumable(photoWithLicenseRef(uid),imageBlob, metadata);
    let image1 = await getDownloadURL(photoWithLicenseRef(uid));
    profile.photoWithLicense = image1;
  }
  if(imageType === 'policeClearance'){
    const isPdf = imageBlob.type === 'application/pdf';
    const metadata = { contentType: isPdf ? 'application/pdf' : getContentType(imageBlob) };
    await uploadBytesResumable(policeClearanceRef(uid),imageBlob, metadata);
    let image1 = await getDownloadURL(policeClearanceRef(uid));
    if (isPdf) image1 += image1.includes('?') ? '&ext=.pdf' : '?ext=.pdf';
    profile.policeClearance = image1;
  }
  update(singleUserRef(uid),profile);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
};

export const deleteUser = (uid) => async (dispatch) => {
  const {
    auth,
    singleUserRef,
    walletHistoryRef,
    userNotificationsRef,
    addressEditRef,
    userLocationRef,
    carsRef,
    carEditRef
  } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: uid
  });

  if (auth.currentUser && auth.currentUser.uid === uid) {
    off(singleUserRef(uid));
    off(walletHistoryRef(uid));
    off(userNotificationsRef(uid));
    off(addressEditRef(uid));
    off(userLocationRef(uid));
  }

  try {
    const userdata = await get(singleUserRef(uid));
    if (userdata.exists()) {
      const profile = userdata.val();
      if(profile && profile.usertype === 'driver'){
        const carssnapshot = await get(carsRef(uid, profile.usertype));
        if (carssnapshot.exists()) {
          let cars = carssnapshot.val();
          if (cars) {
            const arr = Object.keys(cars);
            for(let i = 0; i < arr.length; i++){
              await remove(carEditRef(arr[i]));
            }
          }
        }
      } 
    }
    await remove(walletHistoryRef(uid));
    await remove(userNotificationsRef(uid));
    await remove(addressEditRef(uid));
    await remove(userLocationRef(uid));
    
    await revokeUserTokens(uid);
    
    if (auth.currentUser && auth.currentUser.uid === uid) {
      await signOut(auth);
      dispatch({
        type: USER_DELETED,
        payload: null
      });
    } else {
      dispatch({
        type: DELETE_USER_SUCCESS,
        payload: null
      });
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    dispatch({
      type: DELETE_USER_FAILED,
      payload: error
    });
  }
}
